var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"20","key":0}),React.createElement("path",{"clipRule":"evenodd","d":"M24.8605 19.9936H22.1221V30.0257H17.9732V19.9936H16V16.4679H17.9732V14.1863C17.9732 12.5548 18.7482 10 22.159 10L25.2322 10.0129V13.4351H23.0024C22.6367 13.4351 22.1224 13.6179 22.1224 14.3962V16.4711H25.2229L24.8605 19.9936Z","fill":"white","key":1})]);
}

Facebook.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40"};

module.exports = Facebook;

Facebook.default = Facebook;
